"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asTypedConfigurationUnion = exports.isConfigurationUnion = void 0;
const EspoolConfigurationModel_1 = require("./EspoolConfigurationModel");
const EmptyConfigurationModel_1 = require("./EmptyConfigurationModel");
const KetteConfigurationModel_1 = require("./KetteConfigurationModel");
const EspoolChildConfigurationModel_1 = require("./EspoolChildConfigurationModel");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const isConfigurationUnion = (whatever) => (0, EmptyConfigurationModel_1.isEmptyConfigurationModel)(whatever) ||
    (0, KetteConfigurationModel_1.isKetteConfigurationModel)(whatever) ||
    (0, EspoolConfigurationModel_1.isEspoolConfigurationModel)(whatever) ||
    (0, EspoolChildConfigurationModel_1.isEspoolChildConfigurationModel)(whatever);
exports.isConfigurationUnion = isConfigurationUnion;
const asTypedConfigurationUnion = (config) => {
    if ((0, EmptyConfigurationModel_1.isEmptyConfigurationModel)(config)) {
        return { type: 'Empty', config };
    }
    if ((0, EspoolConfigurationModel_1.isEspoolConfigurationModel)(config)) {
        return { type: 'Espool', config };
    }
    if ((0, EspoolChildConfigurationModel_1.isEspoolChildConfigurationModel)(config)) {
        return { type: 'EspoolChild', config };
    }
    if ((0, KetteConfigurationModel_1.isKetteConfigurationModel)(config)) {
        return { type: 'Kette', config };
    }
    (0, echain_shared_ts_utils_1.assertUnreachable)(config);
};
exports.asTypedConfigurationUnion = asTypedConfigurationUnion;
//# sourceMappingURL=ConfigurationUnion.js.map